<div class="l-title">
  <!-- <h2 class="c-title">{{ label }}</h2> -->
  <span class="c-label">{{ label }}</span>
  <h2 class="c-title">{{ title }}</h2>
</div>
